"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jan Prokop
 */


var CommonReleaseOverviewConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CommonReleaseOverviewConverter, _DataObjectConverter_);

  function CommonReleaseOverviewConverter() {
    _classCallCheck(this, CommonReleaseOverviewConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CommonReleaseOverviewConverter).apply(this, arguments));
  }

  return CommonReleaseOverviewConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CommonReleaseOverviewConverter = CommonReleaseOverviewConverter;